















































import rgbHex from "rgb-hex";

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";

import DxColorBox from "devextreme-vue/color-box";

import { SelectOption, Photo } from "@/models";
import MenuItem from "./MenuItem.vue";

@Component({
  components: {
    MenuItem,
    DxColorBox
  }
})
export default class extends Vue {
  @Prop({ type: Object, required: true }) editor: any;
  @Prop() headers: Photo[];
  @Prop() footers: Photo[];
  @Prop({ default: true }) fontcontrolvisible: boolean;
  @Prop({ default: false }) isattachmentlink: boolean;
  @Prop({ default: "" }) public getattachmentlink: string;

  public init() {
    this.items = [];

    this.headerFooterSet();
  }

  public font: SelectOption = { name: "Standard", slug: "Standard" };
  public fontlist: string[] = [
    "Standard",
    "-apple-system",
    "BlinkMacSystemFont",
    "Segoe UI",
    "Roboto",
    "Helvetica Neue",
    "Arial",
    "Noto Sans",
    "sans-serif",
    "SFMono-Regular",
    "Menlo",
    "Monaco",
    "Consolas",
    "Liberation Mono",
    "Courier New",
    "monospace"
  ];
  public fontnamelist: string[] = [
    "Standard",
    "Apple",
    "Blink Mac",
    "Segoe",
    "Roboto",
    "Helvetica Neue",
    "Arial",
    "Noto Sans",
    "Sans Serif",
    "SF Mono Regular",
    "Menlo",
    "Monaco",
    "Consolas",
    "Liberation Mono",
    "Courier New",
    "monospace"
  ];
  public fontsize: string = "Standard";
  public fontsizelist: string[] = [
    "Standard",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "18",
    "20",
    "22",
    "24"
  ];

  public items: any = [];
  public color: string = "";
  mounted() {
    this.init();
    this.editor.on("selectionUpdate", (e: any) => {
      for (let i = 0; i < this.fontlist.length; i++) {
        if (
          this.editor.isActive("textStyle", { fontFamily: this.fontlist[i] })
        ) {
          this.font = { name: this.fontnamelist[i], slug: this.fontlist[i] };
          break;
        } else {
          this.font = { name: "Standard", slug: "Standard" };
        }
      }
      for (let i = 0; i < this.fontsizelist.length; i++) {
        if (
          this.editor.isActive("textStyle", {
            fontSize: this.fontsizelist[i] + "px"
          })
        ) {
          this.fontsize = this.fontsizelist[i];
          break;
        } else {
          this.fontsize = "Standard";
        }
      }
      let currentcolor: string = this.editor.getAttributes("textStyle").color;
      if (currentcolor && currentcolor.startsWith("rgb"))
        this.color = "#" + rgbHex(currentcolor);
      else this.color = currentcolor;
    });
  }

  get fontoptions(): SelectOption[] {
    let options: SelectOption[] = [];
    for (let i = 0; i < this.fontlist.length; i++) {
      if (this.fontlist[i] != "Standard")
        options.push({ name: this.fontnamelist[i], slug: this.fontlist[i] });
    }
    options.sort((f1: SelectOption, f2: SelectOption) =>
      f1.name.localeCompare(f2.name)
    );
    options.unshift({ name: "Standard", slug: "Standard" });
    return options;
  }

  public onSelectFont(val: SelectOption) {
    this.font = val;
    if (this.font.slug === "Standard") {
      this.editor
        .chain()
        .focus()
        .unsetFontFamily()
        .run();
    } else {
      this.editor
        .chain()
        .focus()
        .setFontFamily(val.slug)
        .run();
    }
  }

  public onSelectFontSize(val: string) {
    if (val === "Standard") {
      this.editor
        .chain()
        .focus()
        .unsetFontSize()
        .run();
    } else {
      this.editor
        .chain()
        .focus()
        .setFontSize(val)
        .run();
    }
  }

  public onSelectColor(val: String) {
    this.editor
      .chain()
      .focus()
      .setColor(val)
      .run();
  }

  public headerFooterSet() {
    this.items = [
      {
        icon: "fas fa-bold",
        title: "Bold",
        action: () =>
          this.editor
            .chain()
            .focus()
            .toggleBold()
            .run(),
        isActive: () => this.editor.isActive("bold")
      },
      {
        icon: "fas fa-italic",
        title: "Italic",
        action: () =>
          this.editor
            .chain()
            .focus()
            .toggleItalic()
            .run(),
        isActive: () => this.editor.isActive("italic")
      },
      {
        type: "divider"
      },
      {
        icon: "fas fa-align-right",
        title: "Right",
        action: () =>
          this.editor
            .chain()
            .focus()
            .setTextAlign("right")
            .run(),
        isActive: () => this.editor.isActive("right")
      },
      {
        icon: "fas fa-align-justify",
        title: "Justify",
        action: () =>
          this.editor
            .chain()
            .focus()
            .setTextAlign("justify")
            .run(),
        isActive: () => this.editor.isActive("justify")
      },
      {
        icon: "fas fa-align-left",
        title: "Left",
        action: () =>
          this.editor
            .chain()
            .focus()
            .setTextAlign("left")
            .run(),
        isActive: () => this.editor.isActive("left")
      },
      {
        icon: "fas fa-align-center",
        title: "Center",
        action: () =>
          this.editor
            .chain()
            .focus()
            .setTextAlign("center")
            .run(),
        isActive: () => this.editor.isActive("center")
      },
      {
        type: "divider"
      },
      {
        icon: "fas fa-list",
        title: "Bullet List",
        action: () =>
          this.editor
            .chain()
            .focus()
            .toggleBulletList()
            .run(),
        isActive: () => this.editor.isActive("bulletList")
      },
      {
        icon: "fas fa-list-ol",
        title: "Ordered List",
        action: () =>
          this.editor
            .chain()
            .focus()
            .toggleOrderedList()
            .run(),
        isActive: () => this.editor.isActive("orderedList")
      },
      {
        type: "divider"
      },
      {
        icon: "fas fa-undo",
        title: "Undo",
        action: () =>
          this.editor
            .chain()
            .focus()
            .undo()
            .run()
      },
      {
        icon: "fas fa-redo",
        title: "Redo",
        action: () =>
          this.editor
            .chain()
            .focus()
            .redo()
            .run()
      },
      {
        type: "divider"
      },
      {
        icon: "fas fa-minus",
        title: "Horizontal line",
        action: () =>
          this.editor
            .chain()
            .focus()
            .setHorizontalRule()
            .run()
      },
      {
        type: "divider"
      }
    ];
    if (this.headers) {
      let menuitems: any = this.headers.map((header: Photo) => {
        return {
          icon: "fa-regular fa-window-maximize",
          title: "Add company header",
          action: () =>
            this.editor
              .chain()
              .focus()
              .setImage({ src: this.$onecentral.resizedPhotoSrc(header, 400) })
              .run()
        };
      });

      this.items = this.items.concat(menuitems);
      this.items = [...this.items, { type: "divider" }];
    }
    if (this.footers) {
      let menuitems: any = this.footers.map((footer: Photo) => {
        return {
          icon: "fa-regular fa-window-maximize fa-rotate-180",
          title: "Add company footer",
          action: () =>
            this.editor
              .chain()
              .focus()
              .setImage({ src: this.$onecentral.resizedPhotoSrc(footer, 400) })
              .run()
        };
      });
      this.items = this.items.concat(menuitems);
      this.items = [...this.items, { type: "divider" }];
    }
    if (this.isattachmentlink && this.getattachmentlink != "") {
      let menuitems: any = {
        icon: "fa fa-download",
        title: "Add attachment link",
        action: () => {
          this.editor
            .chain()
            .focus()
            .setColor("black")
            .run();
          this.editor
            .chain()
            .focus()
            .insertContent(
              `Click <a href='${this.getattachmentlink}' download>here</a> to download the report`
            )
            .run();
        }
      };
      this.items = this.items.concat(menuitems);
      this.items = [...this.items, { type: "divider" }];
    }
  }
}
